import SiteLayout from '@/components/feature/SiteLayout';
import useDocumentMeta from '@/hooks/useDocumentMeta';
import type { ContentItem } from '@/types/content';
import { getItemsByType, sortByTime } from '@/utils/content';
import HeroSection from '@/pages/home/components/HeroSection';
import QuickEntries from '@/pages/home/components/QuickEntries';
import NewsSpotlight from '@/pages/home/components/NewsSpotlight';
import LifePicks from '@/pages/home/components/LifePicks';
import EntHot from '@/pages/home/components/EntHot';
import TopicSpots from '@/pages/home/components/TopicSpots';
import IntroBand from '@/pages/home/components/IntroBand';

export default function Home() {
  useDocumentMeta({
    title: '91网站——权威综合门户资讯及服务平台',
    description:
      '91网站提供丰富的新闻资讯、生活服务及娱乐内容，覆盖多个领域，满足用户多样化的信息需求和在线服务体验。',
    keywords: '91网站,综合门户,新闻资讯,生活服务,娱乐内容,信息平台,线上服务',
  });

  const news = sortByTime(getItemsByType('news'));
  const services = getItemsByType('service');
  const entertainment = getItemsByType('entertainment');

  const slides: ContentItem[] = [...news].sort((a, b) => (b.views || 0) - (a.views || 0)).slice(0, 5);
  const latestNews = news.slice(0, 6);

  return (
    <SiteLayout>
      <h1 className="sr-only">91网站——权威综合门户资讯及服务平台</h1>
      <HeroSection slides={slides} latest={latestNews} />
      <QuickEntries />
      <NewsSpotlight items={news.slice(0, 4)} />
      <LifePicks items={services} />
      <EntHot items={entertainment} />
      <TopicSpots />
      <IntroBand />
    </SiteLayout>
  );
}